import { Box, Button, Stack, Typography, FormGroup, FormControlLabel, Checkbox } from "@mui/material";

import { NavLink } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { useState } from "react";

import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import DashedBreakline from "../../../../components/Shared/DashedBreakline";

export default function RegisterAccountType({ setConfirmedType }: any) {
  const [type, setType] = useState<string>('business')
  const [accepted, setAccepted] = useState<boolean>(false)

  return (
    <Box>
      <Box sx={{ p: 2, border: `1px solid ${grey[200]}`, mb: 1, cursor: 'pointer', bgcolor: type === 'business' && grey[100] || 'unset' }} onClick={() => setType('business')}>
        <Stack direction="row">
          {type === 'business' ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
          <Box sx={{ ml: 2 }}>
            <Typography fontSize={14} fontWeight={700}>Business Account</Typography>
            <Typography fontSize={14}>Take advantage of our comprehensive solutions and dedicated support to drive business success.</Typography>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ p: 2, border: `1px solid ${grey[200]}`, cursor: 'pointer', bgcolor: type === 'individual' && grey[100] || 'unset' }} onClick={() => setType('individual')}>
        <Stack direction="row">
          {type === 'individual' ? (<RadioButtonCheckedIcon />) : (<RadioButtonUncheckedIcon />)}
          <Box sx={{ ml: 2 }}>
            <Typography fontSize={14} fontWeight={700}>Individual Account</Typography>
            <Typography fontSize={14}>For individual needs and personal use.</Typography>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ mt: 2 }}>
        <FormGroup>
          <FormControlLabel control={<Checkbox onChange={(event) => setAccepted(event.target?.checked)} />} componentsProps={{ typography: { fontSize: 14 } }} label={<Typography sx={{ fontSize: 13 }}>By clicking, you acknowledge and agree to the VNETWORK JSC  <Typography component={NavLink} fontSize={14} fontWeight={700} target="_blank" to="https://www.vnetwork.vn/en-US/terms-of-service/" sx={{ color: 'black ! important' }}>Terms of Service</Typography>.</Typography>} />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button component="span" variant="contained" fullWidth disabled={accepted === false} onClick={() => setConfirmedType(type)}>
          <Typography sx={{ fontSize: 14, fontWeight: 500, textTransform: 'capitalize' }}>
            Next
          </Typography>
        </Button>
      </Box>

      <DashedBreakline text="Already a member?" />

      <Button component={NavLink} to="/auth/login" fullWidth sx={{ bgcolor: grey[50], color: 'black ! important' }}>
        <Typography sx={{ fontSize: 14, fontWeight: 500, textTransform: 'capitalize' }}>
          Login
        </Typography>
      </Button>
    </Box>
  )
}